class CustomProduct {
  constructor(data) {
    // Pass data as a parameter for flexibility and separation of concerns
    this.data = data;
  }

  /**  Find a product type key in the map based on the product title.
   *   param: typeMap - A map of product types with keywords as keys.
   *   returns: The product type key if found in title, otherwise null.
   **/
  findProductType(typeMap) {
    const productTitleElement = document.querySelector('.product-title');
    if (!productTitleElement) {
      console.error('Product title element not found');
      return null;
    }

    const productTitle = productTitleElement.textContent
      .toLowerCase()
      .split(' ');
    for (const key in typeMap) {
      const keywords = key.toLowerCase().split(' ');
      if (keywords.every((word) => productTitle.includes(word))) {
        return key;
      }
    }
    return null;
  }

  // Helper function to add Font Awesome to the page.
  addFontAwesome() {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href =
      'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
    document.head.appendChild(link);
  }

  // Helper function to add styles to the page.
  addStyles(styles) {
    const style = document.createElement('style');
    style.textContent = styles;
    document.head.appendChild(style);
  }

  // Function to remove the product reference number at end of the product title.
  removeRefFromTitle() {
    const productTitleElement = document.querySelector('.product-title');
    if (!productTitleElement) {
      console.error('Product title element not found');
      return;
    }

    let productTitle = productTitleElement.textContent.trim();
    productTitle = productTitle.replace(/\s*\d+$/, '');
    productTitleElement.textContent = productTitle;
  }

  // Converts sizes on the product page to Brazilian equivalents
  convertSize() {
    const sizeMap = this.data.sizeMap;
    const sizeType = this.findProductType(sizeMap);
    if (!sizeType) {
      console.error('Product type not found for size conversion.');
      return;
    }

    const originalFieldset = document.querySelector('fieldset.option-selector');
    if (!originalFieldset) {
      console.error('Size fieldset not found');
      return;
    }

    originalFieldset.querySelectorAll('span').forEach((span) => {
      const originalSize = span.textContent.trim();
      const newSize = sizeMap[sizeType][originalSize];
      if (newSize) {
        span.textContent = `US ${originalSize} | BR ${newSize}`;
      }
    });
  }

  // Display size chart for women's jeans
  displayWomensJeansChart() {
    const womensJeansChartMap = this.data.womensJeansChartMap;
    const chartType = this.findProductType(womensJeansChartMap);
    if (!chartType) {
      console.error('Chart type not found for women’s jeans');
      return;
    }

    const productDescription = document.querySelector('.product-description');
    if (!productDescription) {
      console.error('Product description element not found');
      return;
    }

    const chartDiv = document.createElement('div');
    chartDiv.classList.add('size-chart');
    chartDiv.innerHTML = `
          <h3>Size Chart</h3>
          <div class="table-container" style="overflow-x:auto;text-wrap:nowrap;">
            <table>
              <thead>
                <tr><th>US Size</th><th>Brazil Size</th><th>Waist (inches)</th><th>Hip (inches)</th></tr>
              </thead>
              <tbody>
                ${Object.keys(womensJeansChartMap[chartType])
                  .map((size) => {
                    const inches = womensJeansChartMap[chartType][size].in;
                    return `<tr><td>${size}</td><td>${this.data.womensJeans[size]}</td><td>${inches[0]}</td><td>${inches[1]}</td></tr>`;
                  })
                  .join('')}
              </tbody>
            </table>
          </div>
        `;
    productDescription.appendChild(chartDiv);
  }

  // Build the HTML for product features
  buildFeatureHTML(featureData) {
    return `
          <h3>${featureData.heading}</h3>
          ${featureData.features
            .map(
              ({ title, icon, description }) => `
              <div class="feature-box">
                ${icon ? `<i class="fa-solid fa-${icon}"></i>` : ''}
                <h4>${title}</h4>
                <p>${description}</p>
              </div>`
            )
            .join('')}
        `;
  }

  // Display product features
  displayProductFeatures() {
    const featureData = this.data.featureData;
    const productType = this.findProductType(featureData);
    if (!productType) {
      console.error('Product type not found for product features');
      return;
    }

    const productDetails = document.querySelector('.product-details');
    if (!productDetails) {
      console.error('Product details element not found');
      return;
    }

    const section = document.createElement('section');
    section.classList.add('feature-section');
    section.innerHTML = this.buildFeatureHTML(featureData[productType]);

    productDetails.insertAdjacentElement('afterend', section);
  }

  // Build the HTML for customer reviews
  buildReviewHTML(reviews) {
    return reviews
      .map(
        ({ text, author, stars }) => `
            <div class="review-slide">
              <p>${text}</p>
              <p><strong>${author}</strong></p>
              <p>Rating: ${'★'.repeat(stars)}${'☆'.repeat(5 - stars)}</p>
            </div>`
      )
      .join('');
  }

  // Display brand reviews as a slider
  displayBrandReviews() {
    const brandReviews = this.data.brandReviews;
    const productType = this.findProductType(brandReviews);
    if (!productType) {
      console.error('Product type not found for brand reviews');
      return;
    }

    const reviews = brandReviews[productType];
    const productDetails = document.querySelector('.product-details');
    if (!productDetails) {
      console.error('Product details element not found');
      return;
    }

    const sliderContainer = document.createElement('div');
    sliderContainer.classList.add('review-slider');
    sliderContainer.innerHTML = `<h3>Customer Reviews</h3><div class="slider-inner">${this.buildReviewHTML(
      reviews
    )}</div>`;

    productDetails.insertAdjacentElement('afterend', sliderContainer);

    // Slider functionality
    const slides = Array.from(
      sliderContainer.querySelectorAll('.review-slide')
    );
    let currentSlide = 0;

    const showSlide = (index) => {
      slides.forEach((slide, i) => {
        slide.style.display = i === index ? 'block' : 'none';
      });
    };

    const nextSlide = () => {
      currentSlide = (currentSlide + 1) % slides.length;
      showSlide(currentSlide);
    };

    showSlide(currentSlide);
    const intervalId = setInterval(nextSlide, 5000);

    // Stop slider when tab is inactive
    window.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        clearInterval(intervalId);
      }
    });
  }
}

const mensFootwear = {
  6: '36',
  7: '37',
  7.5: '38',
  8: '39',
  9: '40',
  10: '41',
  11: '42',
  12: '43',
  13: '44',
};

const womensFootwear = {
  4: '33',
  5: '34',
  6: '35',
  7: '36',
  8: '37',
  9: '38',
  10: '39',
  11: '40',
  12: '41',
};

const womensJeans = {
  2: '36',
  4: '38',
  6: '40',
  8: '42',
  10: '44',
  12: '46',
  14: '48',
  16: '50',
  18: '52',
  20: '54',
};

const mensJeans = {
  26: '36',
  28: '38',
  30: '40',
  32: '42',
  34: '44',
  36: '46',
  38: '48',
  40: '50',
  42: '52',
  44: '54',
};

// Grouping product types by their associated keywords
const productTypes = {
  mensFootwear: [
    "men's shoe",
    "men's shoes",
    "men's boot",
    "men's boots",
    "men's sneaker",
    "men's sneakers",
    "men's loafer",
    "men's loafers",
    "men's sandal",
    "men's sandals",
  ],
  womensFootwear: [
    "women's shoe",
    "women's shoes",
    "women's sandal",
    "women's sandals",
    "women's clog",
    "women's clogs",
    "women's boot",
    "women's boots",
  ],
  mensJeans: [
    "men's jeans",
    "men's short",
    "men's shorts",
    'jeans homem',
    'jeans masculino',
  ],
  womensJeans: [
    "women's pants",
    "women's short",
    "women's shorts",
    'calça feminina',
    'calça jeans',
    'saia',
    'short feminino',
  ],
};

// Preprocess to create a sizeMap for constant lookup
const sizeMap = {};
for (const [type, keywords] of Object.entries(productTypes)) {
  keywords.forEach((keyword) => {
    sizeMap[keyword] = eval(type); // Dynamically assigns the right size map
  });
}
const productData = {
  sizeMap: sizeMap,
  womensJeansChartMap: {
    "rhero women's": {
      2: {
        cm: ['64-67', '76-79'],
        in: ['25-26', '30-31'],
      },
      4: {
        cm: ['68-71', '80-83'],
        in: ['27-28', '32-33'],
      },
      6: {
        cm: ['72-75', '84-87'],
        in: ['29-30', '34-35'],
      },
      8: {
        cm: ['76-79', '88-91'],
        in: ['31-32', '36-37'],
      },
      10: {
        cm: ['80-83', '92-95'],
        in: ['33-34', '38-39'],
      },
      12: {
        cm: ['84-87', '96-99'],
        in: ['35-36', '40-41'],
      },
      14: {
        cm: ['88-91', '100-103'],
        in: ['37-38', '42-43'],
      },
      16: {
        cm: ['92-95', '104-107'],
        in: ['39-40', '44-45'],
      },
    },
    'pitbull womens jeans': {},
  },

  featureData: {
    'rhero pants': {
      heading: 'Why customers are falling in love with Rhero',
      features: [
        {
          title: 'Brazilian Style Butt Lift',
          description:
            "Rhero's unique Brazilian butt lift technology sculpts and lifts your glutes, giving you a sexy slim look.",
        },
        {
          title: 'High detail and long lasting',
          description:
            'Incredible pants with meticulous hand-made details, in addition to featuring a butt-lifting design, flat stomach and extreme comfort and durability.',
        },
        {
          title: 'Tummy Control',
          description:
            'High waist compression hugs your waist to remove any love handles.',
        },
        {
          title: 'No Waist Gap',
          description:
            'The compression provides tummy and back support to give you an incredible fit every time.',
        },
        {
          title: '100% Made in Brazil',
          description:
            'Premium authentic Brazilian jeans brand renowned for its unique sexy style for over 20 years.',
        },

        {
          title: 'Best Seller',
          description:
            'We have made thousands of customers happy around the world with our best selling jeans, fast shipping, and easy returns.',
        },
      ],
    },
    "piccadilly women's": {
      heading: "Piccadilly's Exclusive Comfort Technology",
      features: [
        {
          title: 'Light and Flexible',
          icon: 'feather',
          description:
            "Air flow that takes the weight off the soles and malleable materials that don't weigh you down when walking, making the shoes lighter and more flexible.",
        },
        {
          title: 'Stability',
          icon: 'chart-simple',
          description:
            'Shoes with heels higher than 1 inch (3 cm) have a piece that provides more stability when walking and super grippy soles that prevent them from slipping off the foot.',
        },
        {
          title: 'Smart Measurements',
          icon: 'ruler',
          description:
            'Shapes with exclusive and intelligent measurements. This means your feet are free from tightness, calluses or pain - even with normal swelling at the end of the day.',
        },
        {
          title: 'Extra Soft Finish',
          icon: 'face-smile',
          description:
            'The insoles are made of a special material that absorbs the impacts of walking, providing comfort and well-being to your feet.',
        },
        {
          title: 'Impact Absorption',
          icon: 'chart-line',
          description:
            'Soles with materials that absorb up to 80% of the impact, providing more comfort and health for your joints.',
        },
        {
          title: 'Temperature Control',
          icon: 'temperature-low',
          description:
            'Our insoles have a hydrophilic treatment. They have a high absorption capacity and keep your feet dry.',
        },
      ],
    },
  },
  videos: {
    "piccadilly women's": {
      title: 'Made with Care for Comfort',
      description:
        'Watch how Piccadilly shoes are made with the best materials and exclusive comfort technology.',
      url: 'https://www.youtube.com/embed/imJzxMKJjF8',
    },
  },

  brandReviews: {
    'rhero pants': [
      {
        text: 'These jeans are a game-changer! They hug my curves perfectly and give such a great lift. 😍',
        author: 'Natalie K.',
        stars: 5,
      },
      {
        text: 'I absolutely 😍 thank youuu',
        author: 'Leticia S.',
        stars: 5,
      },
      {
        text: 'Material incrível! Realmente levanta o bumbum e me sinto super confortável usando.',
        author: 'Fernanda A.',
        stars: 5,
      },
      {
        text: 'La verdad no esperaba que me quedaran tan bien. Estilizan mucho y son muy cómodos.',
        author: 'Valeria M.',
        stars: 4,
      },
      {
        text: 'I’ve never felt so confident in a pair of jeans. These really do what they promise! ❤️',
        author: 'Sophia R.',
        stars: 5,
      },
      {
        text: 'Comprei por indicação de uma amiga e estou apaixonada! Modela o corpo e valoriza muito as curvas. 💃',
        author: 'Bruna L.',
        stars: 5,
      },
    ],
  },
};

// Initialize the class on the page with the sample data
const customProduct = new CustomProduct(productData);
console.log('[Custom Product]: Initialized');
